import g from './globals'
import customSelect from 'custom-select';

if (g.elementInDom('.category-dropdown')) {
    customSelect('#cat')
}
